/** Nearest scrolling ancestor of `from`, or the page scroller. */
export const getScrollContainer = (from: Element | null): Element => {
    for (let el = from?.parentElement; el; el = el.parentElement) {
        const overflowY = getComputedStyle(el).overflowY;
        if ((overflowY === 'auto' || overflowY === 'scroll') && el.scrollHeight > el.clientHeight) {
            return el;
        }
    }
    return document.scrollingElement || document.documentElement;
};

export interface ScrollMetrics {
    scrollTop: number;
    clientHeight: number;
    scrollHeight: number;
}

/**
 * Which "go to top/bottom" shortcuts are useful: only once the user is more than
 * `threshold` px away from that end of the page.
 */
export const getScrollShortcuts = ({ scrollTop, clientHeight, scrollHeight }: ScrollMetrics, threshold = 200) => ({
    canGoTop: scrollTop > threshold,
    canGoBottom: scrollHeight - (scrollTop + clientHeight) > threshold,
});
